import React, { FunctionComponent } from 'react';
import { Form, Field } from 'react-final-form';
import { Flex, Text, RadioField, LoadingButton } from 'mdlkit';
import { FormattedMessage } from 'react-intl';
import { AffiliationGroup, EligibilityCheck } from '../../interfaces/register';

interface Props {
  selectedAffiliationName: string;
  suggestedAffiliations: AffiliationGroup[];
  onSubmit: (values: EligibilityCheck) => void;
  initialValues: EligibilityCheck;
  disableSubmit: boolean;
}

const AffiliationGroupForm: FunctionComponent<Props> = ({
  selectedAffiliationName,
  suggestedAffiliations,
  onSubmit,
  initialValues,
  disableSubmit,
}: Props) => (
  <Flex column align="center">
    <Text pt="md" data-testid="multipleAffiliationText">
      <FormattedMessage
        id="affiliationGroupError.notEligible"
        values={{
          selectedAffiliationName,
        }}
      />
    </Text>

    <Form
      onSubmit={onSubmit}
      initialValues={{
        ...initialValues,
        affiliationId: initialValues.affiliationId.toString(),
      }}
      render={({ handleSubmit, submitting, valid }) => (
        <Flex as="form" column align="center" pt="md" onSubmit={handleSubmit}>
          <div role="radiogroup" aria-labelledby="affiliation">
            {suggestedAffiliations.map((affiliation) => {
              const [value, label] = affiliation;

              return (
                <Field
                  key={label}
                  id={`affiliationGroup_${value}`}
                  type="radio"
                  name="affiliationId"
                  label={label}
                  component={RadioField}
                  value={value.toString()}
                />
              );
            })}
          </div>

          <Field name="affiliationType" type="hidden" component="input" />
          <Field name="firstName" type="hidden" component="input" />
          <Field name="lastName" type="hidden" component="input" />
          <Field name="zip" type="hidden" component="input" />
          <Field name="dobMonth" type="hidden" component="input" />
          <Field name="dobDay" type="hidden" component="input" />
          <Field name="dobYear" type="hidden" component="input" />
          <Field name="gender" type="hidden" component="input" />
          <Field name="memberId" type="hidden" component="input" />
          <Field name="isDependent" type="hidden" component="input" />
          <Field name="primaryFirstName" type="hidden" component="input" />
          <Field name="primaryLastName" type="hidden" component="input" />
          <Field name="primaryDobMonth" type="hidden" component="input" />
          <Field name="primaryDobDay" type="hidden" component="input" />
          <Field name="primaryDobYear" type="hidden" component="input" />
          <Field name="primaryMemberId" type="hidden" component="input" />
          <Field name="primaryGender" type="hidden" component="input" />

          <Field name="relationship" type="hidden" component="input" />

          <LoadingButton
            mt="md"
            id="submitAffiliationGroup"
            type="submit"
            size="large"
            disabled={submitting || !valid || disableSubmit}
            isLoading={submitting || disableSubmit}
          >
            <FormattedMessage id="submitButton" />
          </LoadingButton>
        </Flex>
      )}
    />
  </Flex>
);

export default AffiliationGroupForm;
